import { servicesAdmins } from 'services';
import { TAsyncStatesHandlers } from 'hooks/use-mutation-hook-wrapper';
import { admins as typesAdmin, network } from 'types';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';

const useAdminsPermissionRoleGet = (
    arg0?: TAsyncStatesHandlers<
        network.TQueryDefWrapper<typesAdmin.TAdminPermissionRole[]>,
        string
    >,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<typesAdmin.TAdminPermissionRole[]>,
        string,
        null
    >({
        queryKey: 'adminsPermissionRole',
        queryFn: servicesAdmins.getPermissionRoles,
        queryConfig: arg0,
        values: null,
    });
};

export default useAdminsPermissionRoleGet;
